import { UserAuth } from '../context/AuthContext'

const Footer = (props) => {
  const { user } = UserAuth(); // user credentials
  
  return (
    <>
      {!user?
        <></>
      :
        <footer className="d-flex flex-wrap justify-content-between align-items-center py-4 mt-5 border-top">
          <div className="container">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="col-md-4 d-flex align-items-center">
                <a href="/" className="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
                  <img
                    src="https://firebasestorage.googleapis.com/v0/b/inventoryapp-330808.appspot.com/o/system%2FLogo.png?alt=media&token=4a122e42-8aac-4f96-8221-453a40294d52"
                    style={{width:"30px", height: "30px"}}
                    className="me-2"
                  >
                  </img>
                  &#169; 2022 Inventory Management System
                </a>
              </div>
              <div className="col-md-4 d-flex align-items-center">
                <span href="/" className="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
                  Need help? Email us at <a href="mailto:help.bodegako@gmail.com">help.bodegako@gmail.com</a>
                </span>
              </div>
            </div>
          </div>
        </footer>

      }
    </>
  );
}

export default Footer;
